
import { interpolate } from "../fable_modules/fable-library-js.5.3.0/String.js";
import { HtmlHelper_createElement } from "../fable_modules/Feliz.3.3.3/Html.fs.js";
import { fontSize_textSm, width_wFull, padding_py4, gap_gap$002D2, alignItems_itemsCenter, flexDirection_flexCol, display_flex, tw } from "../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { singleton, ofArray } from "../fable_modules/fable-library-js.5.3.0/List.js";
import { textColor_textNeutral500, borderColor_borderNeutral200 } from "./TailwindExtensions.js";

/**
 * Formats the end-of-list message with proper singular/plural form
 */
export function formatMessage(count) {
    const noun = (count === 1) ? "supporter" : "supporters";
    return `That's everyone! ${interpolate("%d%P()", [count])} ${noun}.`;
}

/**
 * Renders a centered end-of-list message with a subtle top divider
 */
export function view(count) {
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, flexDirection_flexCol, alignItems_itemsCenter, gap_gap$002D2, padding_py4]))], ["children", [HtmlHelper_createElement("hr", singleton(["className", tw(ofArray([width_wFull, borderColor_borderNeutral200]))])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral500]))], ["children", singleton(formatMessage(count))]]))]]]));
}

//# sourceMappingURL=EndOfListMessage.js.map
